import Vue from "vue";
import progressBar from "plugins/progressBar";
import axios from "plugins/axios";
import i18n from "plugins/i18n";
import router from "plugins/router";
import moment from "plugins/moment";
import store from "store/store";
import App from "./App.vue";

Vue.config.productionTip = true;

new Vue({
    axios,
    i18n,
    router,
    store,
    progressBar,
    moment,
   ...App
}).$mount("#app");
